import { Reveal } from "@/components/Reveal";

const SectionHeader = ({ number, eyebrow, title, description, dark = false, align = "left" }) => (
  <Reveal className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <div className={`flex items-center gap-4 ${align === "center" ? "justify-center" : ""}`}>
      {number && (
        <span data-testid="section-number" className="font-serif italic text-gold text-lg">
          {number}
        </span>
      )}
      <span className="h-px w-10 bg-gold/60" />
      <span className={`text-[11px] tracking-[0.32em] uppercase ${dark ? "text-ivory/60" : "text-navy/60"}`}>
        {eyebrow}
      </span>
    </div>
    <h2 className={`font-serif font-medium tracking-tight text-4xl md:text-5xl mt-6 leading-[1.05] ${dark ? "text-ivory" : "text-navy"}`}>
      {title}
    </h2>
    {description && (
      <p className={`mt-6 text-base md:text-lg leading-relaxed font-light ${dark ? "text-ivory/70" : "text-navy/70"}`}>
        {description}
      </p>
    )}
  </Reveal>
);

export default SectionHeader;
